import type { DisplayActionsType, OverlayOptionsType } from '@westwing/appshell_types/customEventTypes';
import { OverlayId } from '../types/types';

//  TODO Use appShell types.
export interface ShowOverlayEventDetail {
    action: DisplayActionsType;
    id: string;
    options?: OverlayOptionsType;
}

export const isShopToClubOverlay = (detail: ShowOverlayEventDetail): boolean => {
    const { id } = detail;
    return (
        (id as unknown as OverlayId) === OverlayId.SHOP_TO_CLUB_REGISTRATION_SINGLE_STEP_OVERLAY ||
        (id as unknown as OverlayId) === OverlayId.SHOP_TO_CLUB_REGISTRATION_MULTI_STEP_OVERLAY
    );
};
